import { useQuery } from '@tanstack/react-query'
import { CourseEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetCourse(courseId: string): {
  course: CourseEntity | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: course,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(
    getCourseQueryKey(courseId),
    async () => {
      return qoursesApi.course.courseControllerGetCourseV1(courseId)
    },
    {
      enabled: !!courseId,
    },
  )

  return { course, isLoading, isError, refetch, isRefetching }
}

export const getCourseQueryKey = (courseId: string) => ['course', courseId]
